import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Denver">
                <h1>Mobile App Developers in Denver</h1>
              </div>
              <p className="main_para">
                Looking for top mobile app developers in Denver, Colorado?
                TekRevol is a premier mobile app development company in Denver,
                utilizing platform-specific frameworks and advanced technologies
                to create exceptional Android and iOS applications. With a
                proven track record of over 100 successful projects, our skilled
                Denver-based team is committed to turning your vision into
                reality with innovative and custom-built mobile solutions.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
